import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { CustomTextArea } from './customTextArea';

const MultiLanguageTextArea = ({
  name,
  currentLanguage = 'en',
  referenceValue = '',
  ...props
}) => {
  const { t } = useTranslation();
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;

  const handleInputChange = (e) => {
    const newValue = {
      ...field.value,
      [currentLanguage]: e.target.value,
    };
    setValue(newValue);
  };

  const getInputValue = () => {
    return field.value?.[currentLanguage] || '';
  };

  return (
    <div className="multilang-textarea-container">
      <div className="formik-custom-field act-inputs-new">
        <label
          className={props.requiredStar ? 'required-stars' : ''}
          htmlFor={props.id || props.name}
        >
          {props.labelText}
        </label>
        <textarea
          {...props}
          name={`${name}.${currentLanguage}`}
          value={getInputValue()}
          onChange={handleInputChange}
          error={meta.touched ? meta.error : 'false'}
        />
        {meta.touched && meta.error && (
          <div className="invalid-feedback">
            {typeof meta.error === 'string'
              ? meta.error
              : meta.error[currentLanguage] || Object.values(meta.error)[0]}
          </div>
        )}
      </div>

      {referenceValue && currentLanguage !== 'en' && (
        <div className="reference-text">
          <small className="text-muted">
            {t('common.reference')}: "{referenceValue}"
          </small>
        </div>
      )}
    </div>
  );
};

export default MultiLanguageTextArea;
